<template>
  <div class="top-bar" :class="{ 'pl-222px': !sidebarMini, 'pl-92px': sidebarMini }">
    <div class="title-block">
      <router-link v-if="routeLinkBack" :to="routeLinkBack" class="back-link">
        <span class="back-link-arrow">
          <svg
            width="10"
            height="14"
            viewBox="0 0 10 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.17648 12.8237L1.82354 7.0002L8.17648 1.17667"
              stroke="black"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </router-link>
      <span class="title">{{ $t(pageName) }}</span>
      <span class="title-devide">-</span>
      <span class="campaign-name">{{ title }}</span>
    </div>
    <div class="button-block">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TopBar',
  props: {
    title: {
      type: String,
    },
    routeLinkBack: {
      type: String,
    },
    pageName: {
      type: String,
      default: 'pages.campaignForm.title',
    },
  },
  computed: {
    sidebarMini() {
      return this.$store.state.sideBarMini;
    },
  }
});
</script>

<style scoped>
.top-bar {
  width: 100%;
  height: 68px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 76px;
  left: 0;
  padding-right: 32px;
  margin-top: 0;
  transition: padding-left 0.2s;

  font-family: 'noto-sans', sans-serif;
  font-style: normal;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.02em;
  color: #44485e;
  z-index: 50 !important;
}
.title-block {
  display: flex;
  align-items: center;
  font-weight: normal;
}
.back-link {
  display: flex;
  align-items: center;

  text-decoration: none;
  font-weight: 300;
  color: #44485e;
}
.title {
  margin-left: 20px;
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.02em;
  color: #44485e;
}
.back-link-arrow {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.back-link-arrow svg {
  max-width: 100%;
  max-height: 100%;
}
.title-devide {
  margin: 0 15px;
}
.campaign-name {
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.02em;
}
.button-block {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
